module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "id": "paywall"
    }
  }, [_c('div', {
    attrs: {
      "id": "pay-modal"
    }
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "close"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.paymentModalFeatureNotAvailable'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('mu-icon', {
    attrs: {
      "value": "lock",
      "size": 50,
      "color": "#0179d5"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('message.paymentModalUpgrade')) + " "), _c('strong', {
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize(_vm.paypal.currency_sym + _vm.paypal.amount))
    }
  })])]), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "backgroundColor": "#0179d5",
      "to": "payment",
      "type": "button",
      "label": _vm.$t('message.paymentModalProceedPayment'),
      "fullWidth": ""
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30aed3d4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Payment/Paywall/Paywall.vue
// module id = 3665
// module chunks = 1